import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

function CartLink(props) {
  const { t } = useTranslation();
  const location = useLocation();
  return (
    <Link to="/cart" className={location.pathname === "/cart" ? "active" : ""}>
      {t("cart")}
    </Link>
  );
}

export default CartLink;
